import React from "react";

const TermofUse = () => {



  return (
    <main>
      {/* breadcrumb start */}
      <section className="page-title-wrapper max-md:h-[200px] w-full h-[345px] animate__animated animate__fadeIn">
        <div className="theme-container mx-auto h-full">
          <div className="w-full h-full flex justify-center items-center">
            <h2 className="headline-default text-black max-md:text-white">Term Of Use</h2>
          </div>
        </div>
      </section>
      {/* breadcrumb end */}

      {/* blog start  */}
      <section className="w-full py-16 md:py-[130px]" data-aos="fade">
        <div className="theme-container mx-auto">
          <p className="mb-4 font-medium">
            These Terms &amp; Conditions (“Terms”) govern your access to and
            use of the One Click Doctor website (the “Website”) and the
            SaaS-based healthtech infrastructure we provide (the “Service”).
            By accessing or using the Website or Service, you agree to be
            bound by these Terms.
          </p>
          <p className="mb-2">
            <strong>1. Definitions</strong>
          </p>
          <div>
            <p className="mb-2">
              <strong>“One Click Doctor”</strong> refers to Tank Health and Wellness Pvt. Ltd., the provider of the Service.
            </p>
            <p className="mb-2">
              <strong>“You”</strong> refers to the individual or entity
              accessing or using the Website or Service.
            </p>
            <p className="mb-2">
              <strong>“Content”</strong> refers to any information, data,
              text, software, code, or other materials displayed on or
              available through the Website or Service.
            </p>
            <p className="mb-4">
              <strong>“User”</strong> refers to any individual or entity who
              accesses or uses the Website or Service.
            </p>
          </div>
          <p className="mb-2">
            <strong>2. Use of the Website and Service</strong>
          </p>
          <div>
            <p className="mb-2">
              You may only use the Website and Service for lawful purposes
              and in accordance with these Terms.
            </p>
            <p className="mb-2 font-medium">You agree not to use the Website or Service:</p>
            <div style={{ paddingLeft: 10 }}>
              <p className="mb-2">
                • In a manner that could damage, disable, overburden, or
                impair the Website or Service.
              </p>
              <p className="mb-2">
                • To interfere with any other user’s enjoyment of the
                Website or Service.
              </p>
              <p className="mb-2">
                • To gain unauthorized access to the Website or Service, or
                any computer systems or networks connected to the Website or
                Service.
              </p>
              <p className="mb-2">
                • To upload, transmit, or store any content that is
                unlawful, harassing, defamatory, obscene, or otherwise
                objectionable.
              </p>
              <p className="mb-4">• To violate any applicable laws or regulations.</p>
            </div>
          </div>
          <p className="mb-2">
            <strong>3. User Content</strong>
          </p>
          <div>
            <p className="mb-2">
              You are solely responsible for any content you upload,
              transmit, or store on the Website or Service.
            </p>
            <p className="mb-4">
              You grant Tank Health Wellness Pvt. Ltd.&nbsp; Company a non-exclusive,
              royalty-free license to use, reproduce, modify, publish, and
              distribute your User Content in connection with the Website
              and Service.
            </p>
          </div>
          <p className="mb-2">
            <strong>4. Intellectual Property</strong>
          </p>
          <div>
            <p className="mb-2">
              The Website and Service, including all Content, are protected
              by copyright, trademark, and other intellectual property laws.
            </p>
            <p className="mb-4">
              You agree not to remove, alter, or obscure any copyright
              notices or other proprietary notices placed on the Website or
              Service.
            </p>
          </div>
          <p className="mb-2">
            <strong>5. Disclaimers</strong>
          </p>
          <div>
            <p className="mb-2">
              THE WEBSITE AND SERVICE ARE PROVIDED “AS IS” AND WITHOUT
              WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED. ONE CLICK DOCTOR DISCLAIMS ALL WARRANTIES, INCLUDING, BUT NOT LIMITED
              TO, THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
              PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
            </p>
            <p className="mb-4">
              One Click Doctor DOES NOT WARRANT THAT THE WEBSITE OR SERVICE WILL
              BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE
              CORRECTED, OR THAT THE WEBSITE OR SERVICE IS FREE OF VIRUSES
              OR OTHER HARMFUL COMPONENTS.
            </p>
          </div>
          <p className="mb-2">
            <strong>6. Limitation of Liability</strong>
          </p>
          <div>
            <p className="mb-4">
              One Click Doctor SHALL NOT BE LIABLE FOR ANY DIRECT, INDIRECT,
              INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES
              ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE WEBSITE
              OR SERVICE.
            </p>
          </div>
          <p className="mb-2">
            <strong>7. Term and Termination</strong>
          </p>
          <div>
            <p className="mb-2">
              These Terms shall remain in full force and effect until
              terminated by you or One Click Doctor.
            </p>
            <p className="mb-2">
              One Click Doctor may terminate these Terms at any time, with or
              without cause, upon written notice to you.
            </p>
            <p className="mb-4">
              You may terminate these Terms by discontinuing your use of the
              Website and Service.
            </p>
          </div>
          <p className="mb-2">
            <strong>8. Governing Law</strong>
          </p>
          <div>
            <p className="mb-4">
              These Terms shall be governed by and construed in accordance
              with the laws of India.
            </p>
          </div>
          <p className="mb-2">
            <strong>9. Entire Agreement</strong>
          </p>
          <div>
            <p className="mb-4">
              These Terms constitute the entire agreement between you and
              One Click Doctor with respect to the use of the Website and
              Service.
            </p>
          </div>
          <p className="mb-2">
            <strong>10. Severability</strong>
          </p>
          <div>
            <p className="mb-4">
              If any provision of these Terms is held to be invalid or
              unenforceable, such provision shall be struck and the
              remaining provisions shall remain in full force and effect.
            </p>
          </div>
          <p className="mb-2">
            <strong>11. Waiver</strong>
          </p>
          <div>
            <p className="mb-4">
              No waiver of any provision of these Terms shall be deemed a
              further or continuing waiver of such provision or any other
              provision.
            </p>
          </div>
          <p className="mb-2">
            <strong>12. Update to Terms</strong>
          </p>
          <div>
            <p className="mb-4">
              One Click Doctor may update these Terms at any time by posting the
              amended terms on the Website. Your continued use of the
              Website or Service following the posting of amended Terms
              constitutes your acceptance of the amended Terms.
            </p>
          </div>
          <p className="mb-2">
            <strong>13. Rider Terms</strong>
          </p>
          <p className="mb-4">
            Read all about group care 360 policy terms and conditions <a className="underline text-[#1B467D]" href="https://oneclickdoctor.in/assets/img/group-care-360-policy-terms-and-conditions.pdf" target="_blank">here</a>.
          </p>
          <p className="mb-2">
            <strong>14. Contact Us</strong>
          </p>
          <p className="mb-4">
            If you have any questions about these Terms, please contact us
            at info@oneclickdoctor.in
          </p>
          <p className="mb-2">
            <strong>15. For Group Insurance and Personal Accident Rider</strong>
          </p>
          <p className="mb-4">
            Age limit will be 18-65 years only for primary holder
          </p>
          <p className="mb-2">
            <strong>16. For OPD Wellness Benefits</strong>
          </p>
          <p className="mb-4">
            Age limit will be 0-85 years
          </p>
        </div>
      </section>
      {/* blog end  */}


    </main>
  );
};

export default TermofUse;
